'use client';

/**
 * StatsGrid — N-cell number grid for rail cards.
 *
 * Cards-everywhere-native primitive. Equal-width cells in a horizontal
 * grid; each cell carries a small uppercase label above a larger
 * number. Used by `IntentMatchQualityCard` for the brief/picks/lines
 * trio; reusable wherever a card needs a header-numbers strip.
 *
 * Caller formats the values (percentages, counts, currency) before
 * passing them in — the grid renders raw strings. Cells with `null`
 * values render `—`.
 *
 * @layer presentation
 * @arch_component_type section
 * @arch_domain copilot / rail-insights
 */

import { text } from '@/lib/design/tokens';

interface StatsGridStat {
  label: string;
  value: string | number | null | undefined;
}

interface StatsGridProps {
  stats: StatsGridStat[];
}

export function StatsGrid({ stats }: StatsGridProps) {  if (stats.length === 0) return null;
  return (
    <div
      className="grid gap-2"
      style={{ gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))` }}
    >
      {stats.map((s) => (
        <div key={s.label} className="rounded bg-muted/50 px-2 py-1.5 text-center">
          <p className={text.muted}>{s.label}</p>
          <p className={text.value}>
            {s.value === null || s.value === undefined || s.value === '' ? '—' : s.value}
          </p>
        </div>
      ))}
    </div>
  );
}
